import { Injectable, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CounsellingSessionReviewService {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private collection = this.firestore.collection(this.env.counsellorObservation);

  constructor(private firestore: AngularFirestore) {}

  create(data: any) {
    return this.collection.add(data);
  }
  getDataById(id: string) {
    return this.collection.doc(id).valueChanges({idField:'id'});
  }

  // getAll() {
  //   return this.collection.valueChanges({ idField: 'id' });
  // }

  getAll() {
    return this.firestore.collection(
      this.env.counsellorObservation,
      ref => ref.orderBy('sessionDate', 'desc')
    ).valueChanges({ idField: 'id' });
  }

  getObservationsByDateRange(start: Date | null, end: Date | null): Promise<any[]> {
    if (start && end) {
      return this.firestore.firestore
        .collection(this.env.counsellorObservation)
        .where('sessionDate', '>=', start)
        .where('sessionDate', '<=', end)
        .get()
        .then(snap => snap.docs.map(d => ({ id: d.id, ...d.data() })));
    }
    return this.firestore.firestore
      .collection(this.env.counsellorObservation)
      .get()
      .then(snap => snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }

  update(id: string, data: any) {
    return this.collection.doc(id).update(data);
  }

  deleteRow(id: string) {
    return this.collection.doc(id).delete();
  }
}
